module.exports = __webpack_public_path__ + "img/Cloud Icon - white.7a047ec1.svg";